export default __webpack_public_path__ + "static/media/img-jorgecortes.3547f35d.jpg";